import ArticleCard from 'app/features/Blog/components/ArticleCard'
import { generateArticleLink } from 'app/utils/helpers/blog.helpers'

import ColumnContainer from './ColumnContainer'

interface LeftSideArticlesProps {
  article: BlogArticleModel
  loading?: boolean
  isMobile?: boolean
}

const LeftSideArticles: RFC<LeftSideArticlesProps> = ({
  article,
  loading,
  isMobile
}) => {
  const link = generateArticleLink({
    slug: article.slug,
    categorySlug: article.blog_category?.slug
  })

  return (
    <ColumnContainer sx={{ maxWidth: { xs: '100%', md: 375 }, flexGrow: 2 }}>
      <ArticleCard
        loading={loading}
        link={link}
        createdAt={article.created_at}
        title={article.title}
        image={article.title_image_url}
        imageAltText={article?.title_image?.alt_text}
        imageContainerSx={{
          width: { xs: '100%', md: 342 },
          height: 285
        }}
        index={1}
        isMobile={isMobile}
      />
    </ColumnContainer>
  )
}

export default LeftSideArticles
